/**
 * Recursively removes specified fields from an object or array.
 *
 * @param {any} obj - The object or array to process.
 * @param {string[]} fields - Array of field names to remove (defaults to ["__typename", "_id"]).
 * @returns {any} - A new object or array with the specified fields removed.
 */
export function removeFields(obj, fields = ["__typename", "_id"]) {
  if (Array.isArray(obj)) {
    return obj.map((item) => removeFields(item, fields));
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      if (!fields.includes(key)) {
        acc[key] = removeFields(obj[key], fields);
      }
      return acc;
    }, {});
  }
  return obj;
}
